module.exports = __webpack_public_path__ + "img/martin-alberto-vizcarra-cornejo.9a338710.png";